import React from 'react';
import PanelText from './panel_text';
import PanelImage from '../containers/panel_image';

const Panel = ({ panelContent }) => {
  const panelItems = panelContent.map((panelItem, i) => {
    if (panelItem.type == 'text') {
      return <PanelText key={i} title={panelItem.title} description={panelItem.description} />;
    } else {
      return <PanelImage key={i} imageUrl={panelItem.url} imageSize={panelItem.size} />;
    }
  });
  return <ul className="panel">{panelItems}</ul>;
};

export default Panel;



// WEBPACK FOOTER //
// ./src/components/panel.js